<template>
<!--컨텐츠-->
	<div class="contents contents--full">
		<div class="contents__wrap">

			<!--페이지 상단-->
			<div class="sub-top">
				<h3>평가원 관리</h3>
				<div class="sub-top__navi">
					<span class="icon-home navi--home"></span>
					<span>평가원 관리</span>
				</div>
			</div>
			<div v-if="isLoading" class="loading-overlay">
				<div class="spinner"></div>
				<p>해당 평가원에게 승인완료 이메일 보내는중...</p>
			</div>

			<!--검색박스-->
			<div class="searchbox spacing--xs">
				<div class="searchbox__box">
					<div class="searchbox__frame">
						<div>
							<select v-model="searchCode">
								<option value="all" v-if="!isNameOnly">검색어</option>
								<option value="oName" v-if="!isNameOnly">기관명</option>
								<option value="mName">이름</option>
							</select>
						</div>
						<div>
							<select v-model="searchState">
								<option value="all">상태</option>
								<option value="state1">활성화</option>
								<option value="state0">비활성화</option>
							</select>
						</div>
						<div>
							<select v-model="searchPriv">
								<option value="all">등급</option>
								<option value="sAdmin" v-if="checkUserId.privilege == 'sAdmin'">EQC</option>
								<option value="admin">IQC</option>
								<option value="user">IQA</option>
							</select>
						</div>
						<div>
							<select v-model="searchArd">
								<option value="all">평가권한</option>
								<option value="ardState1">설정완료</option>
								<option value="ardState0">미설정</option>
							</select>
						</div>
						<div class="searchbox__input">
							<div class="input-btn">
								<input type="text" placeholder="내용을 입력해주세요 " v-model="searchText" @keyup.enter="gridLoad">
								<button type="button" @click="gridLoad" class="btn btn--primary btn--icon icon-search"></button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--목록-->
			<div class="btns btns--right spacing--sm">
				<button type="button" class="btn btn--sm btn--excel icon-calandar" v-if="checkUserId.privilege == 'sAdmin'" @click="downloadExcel(checkUserId.organizationCode)" >엑셀 다운로드</button>
				<button type="button" class="btn btn--sm btn--secondary icon-check-circle" @click="openOrgApprovedStandard(checkUserId.organizationCode,checkUserId.organizationName)" >평가 권한설정</button>
				<button type="button" class="btn btn--sm btn--primary icon-bin" @click="deleteOrgInfo()" v-if="checkUserId.privilege == 'sAdmin'">계정 삭제</button>
			</div>
			<div class="table__wrap spacing--xxxs">
				<table class="table table--split" style="min-width:768px;">
					<tr>
						<th>
							<input type="checkbox" id="check_all" @change="toggleAll(isAllChecked)" v-model="isAllChecked">
							<label for="check_all"></label>
						</th>
						<th>No</th>
						<th>아이디</th>
						<th>이름</th>
						<th>기관</th>
						<th>이메일</th>
						<th>등급</th>
						<th @click="sortByDate" style="cursor: pointer;">
							신청일(수정일)
							<span v-if="sortColumn === 'update_at' && sortOrder === 'asc'">🔼</span>
							<span v-if="sortColumn === 'update_at' && sortOrder === 'desc'">🔽</span>
						</th>
						<th>상태</th>
						<!-- <th>관리</th> -->
						<th>평가권한 확인하기</th>
						<th v-if="checkUserId.privilege == 'sAdmin'">평가 배분하기</th>
					</tr>
					<tr v-for="(vo, index) of (checkUserId.privilege === 'sAdmin' ? memberList : memberAdminList)" :key="index">
						<td>
							<input type="checkbox" :id="'check_' + index" v-model="checkedItems[index]">
							<label :for="'check_' + index"></label>
						</td>
						<td>{{vo.no}}</td>
						<td>{{vo.id}}</td>
						<td>{{vo.memberName}}</td>
						<td>{{vo.organizationName}}</td>
						<td>{{vo.userMail}}</td>
						<td v-if ="vo.privilege == 'user'">IQA</td>
						<td v-if ="vo.privilege == 'admin'">IQC</td>
						<td v-if ="vo.privilege == 'sAdmin'">EQC</td>
						<td>{{vo.updateAt}}</td>
						<td>
							<div 
								class="switch"
								:class="{ active: vo.state === 1, inactive: vo.state === 0 }"
								@click="changeStatus(vo.memberCode, vo.state,vo.userMail)"
							>
								<span class="toggle-text left">비활성</span>
								<div class="toggle-container"></div>
								<span class="toggle-text right">활성</span>
							</div>
						</td>
						<!-- <td v-if="vo.state == 0"><button type="button" class="btn btn--primary btn--outline btn--xs" @click="changeStatus(vo.memberCode, vo.state,vo.userMail)" >활성화</button></td> -->
						<!-- <td v-if="vo.state == 1"><button type="button" class="btn btn--alert btn--outline btn--xs" @click="changeStatus(vo.memberCode, vo.state,vo.userMail)" >비활성화</button></td> -->
						<td v-if="vo.approvedStandard == '1'"><button type="button" class="btn btn--primary btn--outline btn--xs" @click="openApprovedStandard(vo.memberCode,vo.organizationCode,vo.memberName)">설정완료</button></td>
						<td v-if="vo.approvedStandard == '0'"><button type="button" class="btn btn--tertiary btn--outline btn--xs" @click="openApprovedStandard(vo.memberCode,vo.organizationCode,vo.memberName)">미설정</button></td>
						<td v-if="checkUserId.privilege == 'sAdmin'"><button type="button" class="btn btn--primary btn--outline btn--xs" @click="openOrgApprovedStandard(vo.organizationCode,vo.organizationName)" >배분하기</button></td>
					</tr>
					
				</table>
			</div>

			<!--페이징-->
		<Pagination v-if="memberJson.pagination" :gridInfo="memberJson" @getGridData="getGridData" @click="goPage()" />
		</div>
	</div>
</template>
   
<script setup>
import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted ,watch } from 'vue'
import Pagination from '@/components/common/grid/pagination'
import memberJson from '@/models/gridInfo/member.json'
import { useRouter } from 'vue-router'
import { updateMemberState,deleteMember,userPwInit,sendUserEmail,getAdminMemberVueList } from '@/api/user'
import * as XLSX from "xlsx";

const store = useStore()
const router = useRouter()
const isLoading = ref(false) // 로딩 상태 변수 추가

const searchText = ref('') // 검색어
const searchCode = ref('all') // 검색어 코드 ex) 기관명 이름름
const searchState = ref('all') // 상태 검색
const searchPriv = ref('all') // 등급검색
const searchArd = ref('all') // 평가 권한 배분 검색(배분 되있는지 안되있는지지)

const checkUserId = computed(() => store.state.temp.userInfo )

const sortColumn = ref('update_at'); // 기본 정렬 컬럼
const sortOrder = ref('desc'); // 기본 정렬 순서

const searchParam = computed(() => {
	return store.state.temp.searchParam 
})

const memberList = computed(() => {
	return store.state.grid.orgData
})

const memberAdminList = computed(() => {
	return store.state.grid.gridData
})

const sortStateOrder = ref('asc'); // 초기 정렬 방향 (오름차순)

// 첫 번째 정렬: 신청일(수정일)
const sortByDate = () => {
    if (sortColumn.value === 'update_at') {
        // 신청일 정렬 토글
        sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
    } else {
        // 첫 번째 정렬을 신청일로 설정
        sortColumn.value = 'update_at';
        sortOrder.value = 'desc';
    }
    getGridData();
};

// 정렬된 목록 반환
const sortedMemberList = computed(() => {
    return [...memberList.value].sort((a, b) => {
        if (sortStateOrder.value === 'asc') {
            return a.state - b.state; // 오름차순
        } else {
            return b.state - a.state; // 내림차순
        }
    });
});

const isNameOnly = computed(() => {
    // 여기에 고정시킬 조건을 입력 (예: 특정 권한, 특정 상태)
    return checkUserId.value.privilege === 'admin';
});

// 조건이 통과되면 searchCode를 'mName'으로 강제 설정
watch(isNameOnly, (newValue) => {
    if (newValue) {
        searchCode.value = 'mName';
    }
}, { immediate: true }); // 컴포넌트가 처음 마운트될 때도 실행

const checkedItems = ref(memberList.value.map(() => false));

const isAllChecked = ref(false)

//const isAllChecked = ref(localStorage.getItem('isAllChecked') === 'true');

const toggleAll = (isAllChecked) => {
	for (let i = 0; i < 11; i++) {
		checkedItems.value[i] = isAllChecked; 
	}
};
watch(checkedItems, (newVal) => {
	if (newVal.every(Boolean) !== isAllChecked.value) {
	// 개별 체크박스 상태가 변경될 때 로직
	}
});

const toggleState = async (memberCode, currentState) => {
    const newState = currentState === 1 ? 0 : 1; // 상태 토글

    try {
        let response = await store.dispatch('grid/updateMemberState', {
            memberCode,
            state: newState,
        });
        if (response?.result === 'ok') {
            alert('상태가 성공적으로 변경되었습니다.');
            getGridData(); // 상태 변경 후 데이터 새로고침
        } else {
            alert(response?.resultMsg || '상태 변경에 실패했습니다.');
        }
    } catch (error) {
        console.error('상태 변경 오류:', error);
        alert('상태 변경에 실패했습니다.');
    }
};


const changeStatus = async (memberCode,state,mail) =>{
	if(state == 1){
		if (confirm("비활성화 처리하시겠습니까? ")) {
			let param = {
				memberCode : memberCode,
			}
			let rtn = await updateMemberState(param)
			
			if (rtn?.result == 'ok') {
				alert(rtn.resultMsg)
				gridLoad();
			} else { 
				alert(rtn.resultMsg)
			}
		}
	}else if(state == 0){
		if (confirm("활성화 처리하시겠습니까? ")) {
			isLoading.value = true; // 로딩 시작
			try{
				let paramMail = {
					userMail : mail
				}

				let rtnMail = await sendUserEmail(paramMail)

				if (rtnMail?.result == 'ok') {
					let param = {
						memberCode : memberCode,
					}
					let rtn = await updateMemberState(param)
					
					if (rtn?.result == 'ok') {
						alert(rtn.resultMsg)
						gridLoad();
					} else { 
						alert(rtn.resultMsg)
					}
					
				} else { 
					alert(rtn.resultMsg)
				}

			} catch (error) {
				
			}finally {
				isLoading.value = false; // 로딩 종료
			}
		}
	}

}

const deleteOrgInfo = async () => {
    // 체크된 항목들의 vo.no를 객체 배열로 저장
    const selectedOrgs = memberList.value
        .filter((notice, index) => checkedItems.value[index])
        .map((selectedMember) => ({ memberCode: selectedMember.memberCode }));

    // 배열에 저장된 객체 배열을 콘솔에 출력
    console.log('Selected Notice Objects:', selectedOrgs);

    if (selectedOrgs.length < 1) {
        alert("선택된 평가원이 없습니다.");
        return false;
    }

    //여기서 deleteNotice API 호출
    if (confirm("정말 삭제하시겠습니까?")) {
        let rtn = await deleteMember(selectedOrgs); // 객체 배열을 그대로 전달
        console.log("선택된 평가원 목록:", selectedOrgs);
        
        if (rtn.result == 'ok') {
            alert(rtn.resultMsg);
            gridLoad();
            // 삭제 후 체크박스 전부 해제
            for (let i = 0; i < checkedItems.value.length; i++) {
                checkedItems.value[i] = false; 
            }
			isAllChecked.value = false
        } else { 
            alert(rtn.resultMsg);
        }
    }
};

//관리자 상세페이지 팝업
const openApprovedStandard = (memberCode,organizationCode,name) => {
	//store.commit('member/setMember/name', name)
	store.commit('member/setMember', memberCode)
	store.commit('member/setOrgCode', organizationCode)
	store.commit('member/setMemberName', name)
    store.commit('temp/setIsApprovedStandard') // 평가 권한 배분 팝업호출
}

//기관별로 스탠다드 항목 배분하기기
const openOrgApprovedStandard = (orgCode,orgName) => {
	store.commit('member/setOrgCode', orgCode)
	store.commit('member/setOrgName', orgName)
    store.commit('temp/setIsOrgApprovedStandard') // 평가 권한 배분 팝업호출
}

const gridLoad = () => {
	store.commit('temp/setSearchParam', {key : 'pageNo', value : 1})
	store.commit('temp/setSearchParam', {key : 'searchCode', value:searchCode.value})
	store.commit('temp/setSearchParam', {key : 'searchText', value:searchText.value})
	getGridData()
}

const getGridData = async () => {
	//fetchAdminUserVue
	if(checkUserId.value.privilege === 'sAdmin'){
		let param = {
			pageNo: searchParam.value.pageNo,
			countPerRecord: searchParam.value.countPerRecord || 10, // 기본값 설정
			search: searchText.value, // 검색어 필터링링
			typeCd: searchCode.value, // 검색어가 기관명인지 이름인지
			searchKind : searchState.value, //  활성화 비활성화 필터링링
			searchArd : searchArd.value, // 배분상태 검색
			searchPriv : searchPriv.value, // 등급검색
			sortColumn: sortColumn.value || 'update_at',
			sortOrder: sortOrder.value || 'desc'
		};
		console.log('Request Params:', param);
		await store.dispatch('grid/fetchUserVue', param)
	}else{
		let param = {
			pageNo : searchParam.value.pageNo,
			countPerRecord : searchParam.value.countPerRecord,
			search : searchText.value,
			typeCd : 'mName', // 일반 관리자는 이름 검색만 있음
			searchKind : searchState.value,
			organizationCode : checkUserId.value.organizationCode,
			searchArd : searchArd.value, // 배분상태 검색
			searchPriv : searchPriv.value, // 등급검색
			sortColumn: sortColumn.value || 'update_at',
			sortOrder: sortOrder.value || 'desc'
		}
		await store.dispatch('grid/fetchAdminUserVue', param)
	}
	
}

const goPage = () => {
	console.log("searchParam.value.pageNo : " + searchParam.value.pageNo)
	// localStorage.setItem('searPageNo', searchParam.value.pageNo);
};

onMounted(async () => {
	store.commit('temp/clearSearchParam')
	getGridData()
})

onUnmounted(() => {
	store.commit('temp/clearSearchParam')
	// 페이지 닫힐 때 해당 리스너 삭제
}) 

// 엑셀 다운로드 함수
const downloadExcel = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 10000,
      search: searchText.value,
      typeCd: searchCode.value,
      searchKind: searchState.value,
      searchArd: searchArd.value,
      searchPriv: searchPriv.value,
      sortColumn: sortColumn.value || 'update_at',
      sortOrder: sortOrder.value || 'desc',
    };

	let rtn = await getAdminMemberVueList(param);

	console.log("데이터 체크" + rtn.data)
    if (rtn && rtn.data) {
      // 데이터 매핑
      const exportData = rtn.data.map((member) => ({
        No: member.no,
        아이디: member.id,
        이름: member.memberName,
        기관: member.organizationName,
        이메일: member.userMail,
        등급:
          member.privilege === 'user'
            ? 'IQA'
            : member.privilege === 'admin'
            ? 'IQC'
            : 'EQC',
        "신청일(수정일)": member.updateAt,
        상태: member.state === 1 ? '활성화' : '비활성화',
        배분상태: member.approvedStandard === '1' ? '설정완료' : '미설정',
      }));

      // 엑셀 생성
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "평가원 관리");

      // 엑셀 파일 다운로드
      const excelFilename = `평가원관리_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(workbook, excelFilename);
    } else {
      console.error("응답 데이터가 비어 있습니다:", rtn.data);
      alert("데이터를 가져오는 중 문제가 발생했습니다.");
    }
  } catch (error) {
    console.error("엑셀 다운로드 오류:", error);
    alert("엑셀 다운로드 중 오류가 발생했습니다.");
  }
};


</script>

<style>
/* 토글 스위치 스타일 (10% 축소) */
.switch {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px; /* 간격 조정 */
    font-family: Arial, sans-serif;
    font-size: 13px; /* 글자 크기 약간 조정 */
    font-weight: bold;
    transform: scale(0.9); /* 전체적으로 90% 축소 */
    transform-origin: center;
}

/* 토글 텍스트 기본 스타일 */
.toggle-text {
    color: #888;
    transition: color 0.3s;
}

/* 활성 텍스트 스타일 */
.toggle-text.active {
    color: #009FDE;
}

/* 토글 버튼 컨테이너 (10% 축소) */
.switch .toggle-container {
    position: relative;
    display: inline-block;
    width: 54px; /* 60px → 54px */
    height: 28px; /* 30px → 28px */
    background-color: #ccc;
    border-radius: 28px;
    transition: background-color 0.3s;
    cursor: pointer;
}

/* 토글 스위치 원 (10% 축소) */
.switch .toggle-container::before {
    content: "";
    position: absolute;
    width: 22px; /* 24px → 22px */
    height: 22px; /* 24px → 22px */
    background-color: white;
    border-radius: 50%;
    top: 3px;
    left: 4px;
    transition: transform 0.3s;
}

/* 비활성 상태 강조 */
.switch.inactive .toggle-text.left {
    color: #009FDE;
}

/* 활성 상태 강조 */
.switch.active .toggle-text.right {
    color: #009FDE;
}

/* 토글 스위치 활성화 (원 이동) */
.switch.active .toggle-container {
    background-color: #009FDE;
}

.switch.active .toggle-container::before {
    transform: translateX(26px); /* 원 이동 거리 조정 */
}

.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	
	.spinner {
		border: 5px solid rgba(255, 255, 255, 0.3);
		border-top: 5px solid white;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
	/* 토글 스위치 스타일 (10% 축소) */
	
</style>